module.exports = __webpack_public_path__ + "static/media/coupon_without_detail.aedd7ce8.svg";